import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpProvider } from "../http/http";

/*
  Generated class for the EarnZidouTogetherProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class EarnZidouTogetherProvider {

  constructor(public http: HttpProvider) {
    console.log('Hello EarnZidouTogetherProvider Provider');
  }

  getActivityInfo(page, pagesize) {
    let params = {page: page, pagesize: pagesize};
    return this.http.hPost('/ActivityEarnZidouTogether/get_info', params)
  }

  getQrcode() {
    return this.http.hPost('/ActivityEarnZidouTogether/get_qrcode')
  }

  getActivityStep() {
    return this.http.hPost('/ActivityEarnZidouTogether/get_activity_step')
  }

  everSavePoster() {
    return this.http.hPost('ActivityEarnZidouTogether/click_save_poster')
  }
}



// WEBPACK FOOTER //
// ./src/providers/earn-zidou-together/earn-zidou-together.ts